import React, { useState } from 'react';
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/bg-index.png'
import home1 from '../../assets/images/home1.png'
import coworking from '../../assets/images/svg/coworking.svg'
import about from '../../assets/images/1.png'


import Navbar from "../../components/navbar";


import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss'
import CompanyLogo from '../../components/companyLogo';
import { pricing, principles } from '../../data/data';

import { FiArrowRight, MdOutlineCheckCircle } from '../../assets/icons/icons'
import Footer from '../../components/footer';
import ScrollTop from '../../components/scrollTop';

export default function Index(){
    let [isOpen, setOpen] = useState(false);
    return(
        <>
        <Navbar/>
        <section className="bg-half-130 d-table w-100 overflow-hidden" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'top'}}>
            <div className="container">
                <div className="row mt-5 align-items-center pt-5">
                    <div className="col-lg-6 col-md-7">
                        <div className="heading-title">
                            <h1 className="heading fw-bold mb-3">Build clean apps <br/> with your web skills</h1>
                            <p className="para-desc text-muted">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <div className="watch-video mt-4 pt-2">
                                <Link to="#" className="btn btn-primary mb-2">Get Started</Link>
                                <Link to="#" onClick={() => setOpen(true)} className="lightbox video-play-icon watch text-dark mb-2 ms-2"><i className="mdi mdi-play play-icon-circle text-center d-inline-block me-2 rounded-circle text-white title-dark position-relative play play-iconbar"></i> Watch Now !</Link>
                            </div>
                            <ModalVideo
                                channel="youtube"
                                youtube={{ mute: 0, autoplay: 0 }}
                                isOpen={isOpen}
                                videoId="yba7hPeTSjk"
                                onClose={() => setOpen(false)} 
                            />
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="bg-saas-shape position-relative">
                            <img src={home1} className="mx-auto d-block" alt=""/>
                        </div>
                    </div>
                </div>
            </div> 
        </section>

        <div className="container py-4">
            <CompanyLogo/>
        </div>

        <section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">Our Principles</h6>
                            <h4 className="title mb-4">Explore our awesome features</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="row">
                            {principles.map(( item, index ) =>{
                                let Icon = item.icon
                                return(
                                    <div className="col-md-6 mt-4 pt-2" key={index}>
                                        <div className="d-flex features feature-primary core-feature rounded p-4">
                                            <div className="icon text-center rounded-circle me-3 mt-2">
                                                <h3 className="mb-0"><Icon className='icons'/></h3>
                                            </div>
                                            <div className="flex-1">
                                                <h5>{item.title}</h5>
                                                <p className="text-muted mb-0">{item.desc}</p>
                                                <div className="mt-2">
                                                    <Link to="#" className="link">Read More <FiArrowRight className="fea icon-sm"/></Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    
                    <div className="col-12 mt-4 pt-2 text-center">
                        <Link to="#" className="text-primary h6 mb-0">Explore all features <FiArrowRight className="fea icon-sm"/></Link>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-5">
                        <img src={coworking} alt=""/>
                    </div>

                    <div className="col-lg-6 col-md-7">
                        <div className="section-title">
                            <h1 className="title mb-3">Measure to decide, <br/> not just to measure.</h1>
                            <p className="para-desc text-muted">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <ul className="list-unstyled text-muted">
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Digital Marketing Solutions for Tomorrow</li>
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Our Talented & Experienced Marketing Agency</li>
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Create your own skin to match your brand</li>
                            </ul>
                            <div className="mt-4">
                                <Link to="#" className="btn btn-primary">Learn more</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-md-5 order-1 order-md-2">
                        <img src={about} className="img-fluid" alt=""/>
                    </div>

                    <div className="col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0 order-2 order-md-1">
                        <div className="section-title">
                            <h1 className="title mb-3">Collaborate with your <br/> team anytime, anywhere.</h1>
                            <p className="para-desc text-muted">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <ul className="list-unstyled text-muted">
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Digital Marketing Solutions for Tomorrow</li>
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Our Talented & Experienced Marketing Agency</li>
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Create your own skin to match your brand</li>
                            </ul>
                            <div className="mt-4">
                                <Link to="#" className="btn btn-primary">Learn more</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="bg-light rounded-md shadow px-4 py-5">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center">
                                <h4 className="title mb-4">Subscribe Our News!</h4>

                                <div className="subcribe-form mt-4 pt-2">
                                    <form>
                                        <div className="mb-0">
                                            <input type="email" id="email" name="email" className="border bg-white rounded-pill" required placeholder="Email Address"/>
                                            <button type="submit" className="btn btn-pills btn-primary">Get Started</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">Our Pricing</h6>
                            <h4 className="title mb-4">Comfortable Plans</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-9 mb-4">
                        {pricing.map(( item, index ) =>{
                            return(
                                <div className="pt-2" key={index}>
                                    <div className="rounded shadow p-4">
                                        <div className="row align-items-center">
                                            <div className="col-md-3">
                                                <h5>{item.title}</h5>
                                                <div className="d-flex text-primary">
                                                    <span className="h6 mb-0 mt-2">$</span>
                                                    <span className="price h2 mb-0">{item.amount}</span>
                                                    <span className="h6 align-self-end mb-1"> /month</span>
                                                </div>
                                            </div>
                
                                            <div className="col-md-6 mt-4 mt-sm-0">
                                                <p className="text-muted mb-0">{item.desc}</p>
                                            </div>
                
                                            <div className="col-md-3 mt-4 mt-sm-0 text-center text-md-end">
                                                <div className="d-grid">
                                                    <Link to="#" className={item.btnClass}>{item.btnText}</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </section>

        <Footer/>
        <ScrollTop/>
        </>
    )
}